<script setup lang="ts">
import { faBell, faBolt } from '@fortawesome/pro-regular-svg-icons';
import AutoReserve from '@files/empty-auto-reserve.svg?component';
import EmptyTracking from '@files/empty-tracking.svg?component';

const { mode } = defineProps<{
    mode: 'autoReserve' | 'tracking';
}>();

const title = computed(() => {
    switch (mode) {
        case 'autoReserve':
            return 'رزرو خودکار';
        case 'tracking':
            return 'رهگیری';
        default:
            return '';
    }
});

const icon = computed(() => {
    switch (mode) {
        case 'tracking':
            return faBell;
        case 'autoReserve':
            return faBolt;
        default:
            return undefined;
    }
});

const description = computed(() => {
    switch (mode) {
        case 'tracking':
            return 'شما می‌توانید برای هر مسیر یا بلیط مشخص، ارزان‌تر شدن قیمت و افزایش ظرفیت آن را رهگیری کنید.';
        case 'autoReserve':
            return 'شما می‌توانید به ازای سفرهای تکمیل شده، برای خرید آنی، پس از موجود شدن ظرفیت از رزرو خودکار استفاده کنید.';
        default:
            return '';
    }
});
</script>
<template>
    <div class="empty-state-root">
        <AutoReserve v-if="mode === 'autoReserve'" />
        <EmptyTracking v-else-if="mode === 'tracking'" />
        <mr-typography weight="700" color="var(--cool-gray-700)">
            هنوز موردی برای {{ title }} اضافه نکرده‌اید.
        </mr-typography>
        <div class="add-track-container">
            <mr-icon v-if="icon" :icon color="var(--blue-400)" />
            <mr-typography
                weight="500"
                color="var(--cool-gray-600)"
                align="center"
            >
                {{ description }}
            </mr-typography>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.empty-state-root {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    @include f-gap(16px, column);
    border-radius: 12px;

    .add-track-container {
        display: flex;
        align-items: center;
        @include f-gap(4px);
    }
}
</style>
